__turbopack_context__.v({
  "Input": "tQoSpW_Input",
  "Label": "tQoSpW_Label",
  "accent": "tQoSpW_accent",
  "content": "tQoSpW_content",
  "hidden": "tQoSpW_hidden",
  "lbl": "tQoSpW_lbl",
  "primary": "tQoSpW_primary",
  "replying": "tQoSpW_replying",
  "root": "tQoSpW_root",
  "submitBtn": "tQoSpW_submitBtn",
});
